module.exports = __webpack_public_path__ + "static/media/Evil Dwarf.7eb460c8.jpg";